import { useQuery } from "urql";

import {
  DashboardOutstandingPrincipalAccumulativeDocument,
  QueryDashboardOutstandingPrincipalAccumulativeArgs,
} from "../../../graphql/generated.ts";

export const useDashboardOutstandingPrincipalAccumulative = (
  variables: QueryDashboardOutstandingPrincipalAccumulativeArgs
) =>
  useQuery({
    query: DashboardOutstandingPrincipalAccumulativeDocument,
    variables,
  });
